import jingguiDefaultAvatar from '../assets/jinggui-default-avatar.png';
import { isJingguiOrg } from '../config/org';
import { ossImage } from './ossImage';

function isRemoteUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

/** Resolve student avatar: DB avatarUrl > Casdoor photo > jinggui default (when configured). */
export function resolveStudentAvatar(
  avatarUrl?: string | null,
  casdoorPhoto?: string | null,
): string {
  const primary = avatarUrl?.trim();
  if (primary) return primary;
  const photo = casdoorPhoto?.trim();
  if (photo) return photo;
  return isJingguiOrg() ? jingguiDefaultAvatar : '';
}

export function studentAvatarImageUrl(
  avatarUrl?: string | null,
  casdoorPhoto?: string | null,
  ossOptions?: Parameters<typeof ossImage>[1],
): string {
  const resolved = resolveStudentAvatar(avatarUrl, casdoorPhoto);
  if (!resolved) return '';
  if (isRemoteUrl(resolved)) {
    return ossImage(resolved, ossOptions);
  }
  return resolved;
}
